import React, { useEffect, useState } from 'react';
import './Offline.css'; 

const Offline = ({ children }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const goOnline = () => setIsOnline(true);
        const goOffline = () => setIsOnline(false);

        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);

        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    if (!isOnline) {
        return (
            <div className="offline-container">
                <div className="offline-card">
                    <div className="offline-icon">📡</div>
                    <h2>You are offline</h2>
                    <p>Please check your internet connection and try again.</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default Offline;
